// extracted by mini-css-extract-plugin
export default {"modal":"SinglePost_modal__Husdm","backBtn":"SinglePost_backBtn__m7bKn","backBtn__icon":"SinglePost_backBtn__icon__47gXd","overlay":"SinglePost_overlay__Z1nqo"};